import { MiddlewareType } from './types';

export const buildRequestMiddleware =
    ({ graphqlUrl, graphqlPathApi }: { graphqlUrl: string; graphqlPathApi: string }): MiddlewareType =>
    async (args, next) => {
        const { context, operation, variables } = args;
        context.url = `${graphqlUrl}/${graphqlPathApi}/graphql`;
        context.request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: operation.text,
                variables,
            }),
        };
        return next(args);
    };
